import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Header from './Headers';
import MetaTags from 'react-meta-tags';
import ReactGA from 'react-ga';

@inject('store')
@observer
class Howitworks extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.initializeReactGA();
        window.scrollTo(0, 0);
        this.props.store.homeType(false);

    }

    initializeReactGA() {
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/howitworks');
    }

    render() {
        return (
            <div>
                <MetaTags>
                    <title>Revfin</title>
                    <meta name="description" content="Some description."/>
                    <meta property="og:title" content="MyApp"/>
                    <meta property="og:image" content="path/to/image.jpg"/>
                </MetaTags>
                <Header/>
                <section className="banner_text headerbg">
                    <div className="container">
                        <div className="aboutusbanner full-w text-center ">
                            <h1 className="full-w tex-center whitecolor fz-20 text-capitalize">how does this app
                                work</h1>
                        </div>
                    </div>
                </section>

                <section className="pdtb-20">
                    <div className="container">
                        <div className="row">

                        </div>


                    </div>
                </section>
            </div>
        )
    }
}


export default Howitworks



// WEBPACK FOOTER //
// ./src/components/howitworks.js